import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  BlueInvoiceInfo,
  GET_RED_INVOICE_ENTRY_PAGE,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess, orderTypeData } from '../../../tools/util'
import _ from 'lodash'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'
import { EXPORT_RED_INVOICE_DETAIL } from '@/api/invoice'
import { convertToReturnOrderDetailItemList } from '../utils'
import { userRouter } from '@/route'

export type AddFinacialData = {
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: string | number
  platform: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  orderStatus?: string
}

const UseLanderInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_RED_INVOICE_ENTRY_PAGE({
      ...params,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setDataSourceAction({
          dataSource: { data: res.data.content, total: res.data.totalCount },
          pageNo: res.data.pageNo,
        }),
      )

      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    const titleList = _.uniq(
      selectedRows.map((item) => item.titleOfTheContractName),
    )
    if (titleList.length > 1) {
      message.warning('不同签约抬头的发票不能合并开票')
      return
    }
    if (_.uniq(selectedRows.map((item) => item.taxRate)).length > 1) {
      message.warning('不同税率的发票不能合并开票')
      return
    }
    history.push('/srm/addRedInvoiceEntry', {
      data: convertToReturnOrderDetailItemList(selectedRows),
      type: 'lander',
      titleOfTheContract: titleList[0],
      orderType: '0',
    })
  }

  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    await EXPORT_RED_INVOICE_DETAIL({ returnOrderIds: idList })
  }
  useEffect(() => {
    getPageData(state)
  }, [])

  const onJumpDetail = (record: any, info: BlueInvoiceInfo) => {
    const url = userRouter[1].url + '/invoiceDetail'
    console.log({ record, info })

    history.replace({
      pathname: url,
      // 跳转至我的发票详情页
      state: {
        id: info.inputInvoiceId,
        // 判断源单类型
        type: 'lander',
        titleOfTheContract: record.titleOfTheContractName,
      },
    })
  }
  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
    onJumpDetail,
  }
}

export default UseLanderInvoiceEntryHook
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  BlueInvoiceInfo,
  GET_RED_INVOICE_ENTRY_PAGE,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess, orderTypeData } from '../../../tools/util'
import _ from 'lodash'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'
import { EXPORT_RED_INVOICE_DETAIL } from '@/api/invoice'
import { convertToReturnOrderDetailItemList } from '../utils'
import { userRouter } from '@/route'

export type AddFinacialData = {
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: string | number
  platform: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  orderStatus?: string
}

const UseLanderInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_RED_INVOICE_ENTRY_PAGE({
      ...params,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setDataSourceAction({
          dataSource: { data: res.data.content, total: res.data.totalCount },
          pageNo: res.data.pageNo,
        }),
      )

      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    const titleList = _.uniq(
      selectedRows.map((item) => item.titleOfTheContractName),
    )
    if (titleList.length > 1) {
      message.warning('不同签约抬头的发票不能合并开票')
      return
    }
    if (_.uniq(selectedRows.map((item) => item.taxRate)).length > 1) {
      message.warning('不同税率的发票不能合并开票')
      return
    }
    history.push('/srm/addRedInvoiceEntry', {
      data: convertToReturnOrderDetailItemList(selectedRows),
      type: 'lander',
      titleOfTheContract: titleList[0],
      orderType: '0',
    })
  }

  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    await EXPORT_RED_INVOICE_DETAIL({ returnOrderIds: idList })
  }
  useEffect(() => {
    getPageData(state)
  }, [])

  const onJumpDetail = (record: any, info: BlueInvoiceInfo) => {
    const url = userRouter[1].url + '/invoiceDetail'
    console.log({ record, info })

    history.replace({
      pathname: url,
      // 跳转至我的发票详情页
      state: {
        id: info.inputInvoiceId,
        // 判断源单类型
        type: 'lander',
        titleOfTheContract: record.titleOfTheContractName,
      },
    })
  }
  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
    onJumpDetail,
  }
}

export default UseLanderInvoiceEntryHook
